// THREE.js adapter over @physics/coords. The pure layer trades in plain
// number tuples; scene/UI callers want Vector3 + a shared THREE.Matrix3 to
// drive the camera basis. This module is the one place that glues them.

import * as THREE from 'three';
import {
  setRotationMatrix,
  physicalToThree,
  threeToPhysical,
  mapPhysicalToThreeWithRotation as mapPure,
} from '@physics/coords';

export let coordinateRotationMatrix: THREE.Matrix3 = new THREE.Matrix3().set(
  1, 0, 0,
  0, 1, 0,
  0, 0, 1,
);

export function setCoordinateRotationMatrix(matrix3: THREE.Matrix3): void {
  coordinateRotationMatrix = matrix3.clone();
  // THREE.Matrix3.elements is column-major; convert to row-major for the pure layer.
  const e = matrix3.elements;
  setRotationMatrix([
    e[0]!, e[3]!, e[6]!,
    e[1]!, e[4]!, e[7]!,
    e[2]!, e[5]!, e[8]!,
  ]);
}

export function physicalToThreeJS(x: number, y: number, z: number): THREE.Vector3 {
  const [a, b, c] = physicalToThree([x, y, z]);
  return new THREE.Vector3(a, b, c);
}

export function threeJSToPhysical(x: number, y: number, z: number): THREE.Vector3 {
  const [a, b, c] = threeToPhysical([x, y, z]);
  return new THREE.Vector3(a, b, c);
}

export function mapPhysicalToThreeWithRotation(physicalVec3: THREE.Vector3 | { x: number; y: number; z: number }): THREE.Vector3 {
  const [a, b, c] = mapPure([physicalVec3.x, physicalVec3.y, physicalVec3.z]);
  return new THREE.Vector3(a, b, c);
}
